module.exports = __webpack_public_path__ + "img/southeast-winter-992x550.cca0050b.jpg";